jQuery.expr[':'].contains = function(a, i, m) {
	return jQuery(a).text().toUpperCase()
			.indexOf(m[3].toUpperCase()) >= 0;
};

function isValidEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function doFaqSearch(query) {
	try{$("#faq-reset-div").show();}catch(e){};
	$('.faq').hide();
	results = $('.faq:contains('+ query +')');
	if(results.length > 0){
		$('.faq-search-no-results').hide();
		results.show();
	} else {
		$('.faq-search-no-results').show();
	}
	$('.title.title--h2').show().each(function(i, v){
		faq_items = $(v).nextUntil(':not(.faq)', ':visible');
		//console.log(faq_items.length);
		if(faq_items.length === 0) {
			$(v).hide();
		}
	});
}

function deleteadvertentie(advertentieid) {
	if (confirm("Weet u zeker dat u deze reactie wilt verwijderen?")) {
		tdatastring="advertentie="+advertentieid+"&action=removeadvertentie";
		$.ajax({
			type: "POST",
			url: "/?pageid=815",
			data: tdatastring,
			success: function(msg){
				alert(msg.message);
				if (msg.success == "true") {
					window.location = window.location;
				}

			},
			error: function(msg){
				alert(msg.responseText);
				window.location = window.location;
			}
		});
	}
}

function doItemSearch(query) {
	$.cookie("lastsearch", query, { path: "/" });
	results = $('.projecten_shadow_list .project:contains('+ query +')').clone();
	$('.woningen-count').text(results.length);
	if(results.length > 0){
		$('.project-search-no-results').hide();
		$('.projecten').html('').append(results);
	} else {
				$('.projecten').html('');
		$('.project-search-no-results').show();
	}
}

function reageer(advertentieid) {
	tdatastring = "advertentie="+advertentieid+"&reageren=true";
	// window.open('#' + tdatastring, '_self');
	$.ajax({
		type: "POST",
		url: "/?pageid=815",
		data: tdatastring,
		success: function(msg) {
			alert(msg.message);
			if (msg.success == "true") {
				window.location = "/?pageid=811&reageer=true"
			}
		},
		error: function(msg) {
			alert(msg.responseText);
		}
	});
}

function loadWinkelmandje() {
	tdatastring = "load";
	window.open('#'+tdatastring, '_self');
	$.ajax({
		type: "POST",
		url: "/?pageid=246",
		data: tdatastring,
		success: function(msg) {
			document.getElementById('winkelmandje').innerHTML = msg;
		},
		error: function(msg) {
			document.getElementById('winkelmandje').innerHTML = 'Error:' + msg.responseText;
		}
	});
}

$(function(){

	// This will create a single gallery from all elements that have class "gallery-item"
	$('.gallery-item').magnificPopup({
		type: 'image',
		gallery:{
			enabled:true
		}
	});

	$('.mapsholder').click(function () {
		$('.mapsholder .holder').css("pointer-events", "auto");
	});
	$('.reset-search').on('click', function(){
		$('.project__input').val('').focus();
		doItemSearch('');
	});

	$('.faqsearchform').on('submit', function(e){
		doFaqSearch($('.faq__input').val());
		e.preventDefault();
	});

	$('[name="projectform"]').on('submit', function(e){
		doItemSearch($('.project__input').val());
		e.preventDefault();
	});

		var pTimer;
		$('.project__search .project__input').on('keyup', function(e){
				if($('.project__input').val().length > 2 || $('.project__input').val().length === 0) {
						clearTimeout(pTimer);
						pTimer = setTimeout(function(){
								doItemSearch($('.project__input').val());
						}, 500);
				}
		});

	if ($('.owl-carousel > .slide').length > 1) {
		var slider = $('.owl-carousel').owlCarousel({
			loop: true,
			items: 1,
			margin: 0,
			nav: false,
			dots: true,
			autoHeight: true,
			autoplay: true
		})
	};

	if ($('.owl-carousel > .slide').length > 1) {
		slider.on('resized.owl.carousel', function (event) {
			$('.owl-carousel').find(
				'.owl-height').css('height',
				$('.owl-carousel').find('.owl-item.active').height()
			);
		})
	};

	// RETINA COOKIE
	$.cookie("isRetina", window.devicePixelRatio > 1, { path: "/" });

	// PLACEHOLDER
	$('[placeholder]').placeholder();

	// REMOVE MARGIN BIJ OPEENVOLGENDE AFBEELDINGEN
	$(".figure--left, .figure--right").each(function() {
		if ($(this).next(".figure--left, .figure--right").length >= 1) {
			if (!$(this).hasClass("figure--no-margin")) {
				$(this).next().addClass("figure--no-margin").after("<div class=\"clear\"></div>");
			}
		}
	});

	// CLEAR CALL TO ACTIONS
	$("a.button").each(function(){
		if ($(this).prev(".button").length < 0) {
			$(this).before("<div class=\"clear\"></div>");
		}
		if ($(this).next(".button").length < 0) {
			$(this).after("<div class=\"clear\"></div>");
		}
	});

	// CLOSE ALERT
	$(".alert").each(function(){
		$(this).find(".close").click(function(e) {
			$(this).closest('.alert').addClass("remove");
			e.preventDefault();
		});
	});

	// MENU
	$(".menu li").hover(function(){
		$(this).addClass("hover");
		$('ul:first',this).css('visibility', 'visible');
	}, function(){
		$(this).removeClass("hover");
		$('ul:first',this).css('visibility', 'hidden');
	});

	// SUBMENU AAN RECHTERKANT TONEN BIJ TE WEINIG RUIMTE
	$(window).on("resize", function() {
		$(".menu__item").each(function() {
			$item = $(this);
			itemOffset = ($(window).width() - ($item.offset().left + $item.outerWidth()));
			$item.removeClass("open-sub--right");

			if(itemOffset < 240 ) {
				$item.addClass("open-sub--right");
			}

		});
	}).trigger("resize");

	$(".menu__item:has(ul)").find("a:first").append('<i class="fa fa-caret-down"></i>');

	// TOGGLE MENU
	$(".toggle-menu").click(function(e) {
		$("body").toggleClass("show-menu");
		$(this).toggleClass("active");
		$(".mobile-menu").width($(".mobile__wrapper").width());
		e.preventDefault();
	});

	$(".toggle-menu-close").click(function(e) {
		$("body").toggleClass("show-menu");
		$(this).toggleClass("active");
		e.preventDefault();
	});


  $(".mobile-menu--main > .mobile-menu__item:has(ul)")
    .find("a:first")
    .addClass('mobile-menu__link--parent')
    .append("<span class='open-sub'>" +
              "<i class='fa fa-chevron-right'></i>" +
            "</span>");

  $(".mobile-menu--sub > .mobile-menu__item:has(ul)")
    .find("a:first")
    .addClass('mobile-menu__link--parent')
    .append("<span class='open-subsub'>" +
              "<i class='fa fa-chevron-right'></i>" +
            "</span>");

  $(".mobile-menu--sub").each(function() {
    var title = $(this).parent("li").find("a:first").text();
    $(this)
      .prepend("<li class='mobile-menu__item mobile-menu__item--header'>" +
                "<a class='mobile-menu__link' href='#'>" +
                  "<span><i class='fa fa-chevron-left'></i></span>" + title +
                "</a>" +
              "</li>");
  });

  $(".mobile-menu--sub-sub").each(function() {
    var title = $(this).parent("li").find("a:first").text();
    $(this)
      .prepend("<li class='mobile-menu__item mobile-menu__item--header'>" +
                "<a class='mobile-menu__link' href='#'>" +
                  "<span><i class='fa fa-chevron-left'></i></span>" + title +
                "</a>" +
              "</li>");
  });

  $(".open-sub").each(function() {
    $(this).click(function(e) {
			$(".mobile-menu--main").addClass("close").removeClass("show");
      $(this).closest(".mobile-menu > .mobile-menu--sub").removeClass("show").addClass("close");
      $(this).closest(".mobile-menu__item").find(".mobile-menu--sub").addClass("show");
      e.preventDefault();
    });
  });

  $(".open-subsub").each(function() {
    $(this).click(function(e) {
			$(this).closest(".mobile-menu--sub").addClass("close").removeClass("show");
      $(this).closest(".mobile-menu--sub > .mobile-menu--sub-sub").removeClass("show").addClass("close");
      $(this).closest(".mobile-menu--sub > .mobile-menu__item").find(".mobile-menu--sub-sub").addClass("show");
      e.preventDefault();
    });
  });

  $(".mobile-menu").width($(".mobile__wrapper").width() - 0);

  $(".mobile-menu--sub > .mobile-menu__item--header a").each(function() {
    $(this).click(function(e) {
      var $parentmenu = $(this).closest(".mobile-menu--sub");
			$parentmenu.removeClass("show");
      $parentmenu.closest(".mobile-menu--main").addClass("show");
      $parentmenu.closest(".mobile-menu--main").removeClass("close");
      e.preventDefault();
    });
  });

  $(".mobile-menu--sub-sub > .mobile-menu__item--header a").each(function() {
    $(this).click(function(e) {
      var $parentmenu = $(this).closest(".mobile-menu--sub-sub");
      $parentmenu.removeClass("show");
      $parentmenu.closest(".mobile-menu--sub").addClass("show");
      $parentmenu.closest(".mobile-menu--sub").removeClass("close");

      e.preventDefault();
    });
  });

	//	FAQ
	$(".answer").hide();
	$(".faq .question").click(function(e){
		if ($(this).attr("active") == "true") {
			$(this).removeAttr("active");
			$(this).removeClass("active").next(".answer").slideUp("fast");
		} else {
			$(".faq .question").removeClass("active").removeAttr("active");
			$(this).attr("active", "true");
			$(".answer").slideUp();
			$(this).addClass("active").next(".answer").slideToggle("fast");
		}
		e.preventDefault();
	});

	$(".faq").each(function() {
		if ($(this).next(".faq").length >= 1) {
			if (!$(this).hasClass("nomargin")) {
				$(this).addClass("nomargin");
			}
		}
	});

	//	TOGGLE PROJECT VIEW
	$(this).find('.toggle').click(function(e) {

		if (!$(this).hasClass("toggle--active")) {
			$('.toggle').removeClass("toggle--active")
			$(this).addClass('toggle--active');
			$('.projecten').toggleClass('projecten--list');
		}
		e.preventDefault();
	});

}); // END FUNCTION

$(window).load(function(){

	// BREEDTE AFBEELDING = MAXIMALE BREEDTE VOOR ONDERSCHRIFT
	$(window).on("resize", function() {
		$("figure").each(function() {
			$(this).find("figcaption").show().css("max-width", $(this).find("img").width());
		});
	}).trigger("resize");

});

function setBannerCookie(bannerID) {
	var expiryDate = new Date();
	expiryDate.setTime(expiryDate.getTime() + ((60 * 60 * 1000) * 24 * 365));
	$.cookie(bannerID, 'true', {
		expires: expiryDate,
		path: '/'
	});
}

// Popup banner
$(function() {
	if ($('.popupbanner').length > 0) {
		var bannerID = $('.popupbanner').attr('id');

		$('.popupbanner__close, .popupbanner--bg').click(function(e) {
			$('body').toggleClass('showbanner');
			setBannerCookie(bannerID);
			e.preventDefault();
		});

		$('.popupbanner__content .link').click(function(e) {
			$('body').toggleClass('showbanner');
			setBannerCookie(bannerID);
			e.preventDefault();
		});

		if($.cookie(bannerID) === undefined) {
			setTimeout(function(){
				$('body').addClass('showbanner');
			}, 1000);
		}
	}
	$('#markasread').click(function(){
		setSubScribeCookie();
		$('body').toggleClass('showsubscribepopup');
	});
});

var subscribeBanner = 'subscribepopup';
$('.popuptrigger').click(function(e){
	if ($('.subscribepopup').length > 0) {


		$('.subscribepopup__close, .subscribepopup--bg').click(function(e) {
			$('body').toggleClass('showsubscribepopup');
			setSubScribeCookie();
			e.preventDefault();
		});

		$('.subscribepopup__content .link').click(function() {
			$('body').toggleClass('showsubscribepopup');
			setSubScribeCookie();
		});


		if($.cookie(subscribeBanner) === undefined) {
			setTimeout(function(){
				$('body').addClass('showsubscribepopup');
			}, 1000);
		}
	} 

	if($.cookie(subscribeBanner) !== undefined) {
		window.open('https://mijn.thuswonen.nl/woningaanbod/inschrijven/index.xml', '_blank');
	}
	e.preventDefault();
});

$('.inschrijflink').click(function(e){
	if ($('.subscribepopup').length > 0) {


		$('.subscribepopup__close, .subscribepopup--bg').click(function(e) {
			$('body').toggleClass('showsubscribepopup');
			setSubScribeCookie();
			e.preventDefault();
		});

		$('.subscribepopup__content .link').click(function() {
			$('body').toggleClass('showsubscribepopup');
			setSubScribeCookie();
		});


		if($.cookie(subscribeBanner) === undefined) {
			setTimeout(function(){
				$('body').addClass('showsubscribepopup');
			}, 1000);
		}
	} 

	if($.cookie(subscribeBanner) !== undefined) {
		window.open('https://mijn.thuswonen.nl/mijn-portaal/', '_blank');
	}
	e.preventDefault();
});

function setSubScribeCookie(){
	var expiryDate = new Date();
	expiryDate.setTime(expiryDate.getTime() + ((60 * 60 * 1000) * 24 * 1));
	$.cookie(subscribeBanner, 'true', {
		expires: expiryDate,
		path: '/'
	});
}


// Colorbox
$(function() {
	// Generic colorbox
	$('.colorbox').colorbox({
		rel: 'colorbox',
		current: 'afbeelding {current} van {total}',
		previous: 'vorige',
		next: 'volgende',
		close: 'sluiten',
		xhrError: 'De inhoud kan niet worden geladen',
		imgError: 'De afbeelding kan niet worden geladen'
	});

	// Show correct image dimensions on mobile
	if ($(window).width() < 1240) {
		$('.colorbox').colorbox({
		maxHeight: '80%',
		maxWidth: '80%',
		width: 'auto',
		height: 'auto',
		reposition: false
		});
	}

	// Determine correct image dimensions
	//   Function doesn't seem to do much??
	$(window).resize(function() {
		if ($(window).width() < 1240) {
		$('.colorbox').colorbox({
			maxHeight: '80%',
			maxWidth: '80%',
			width: 'auto',
			height: 'auto',
			reposition: false
		});
		}
		else {
		$('.colorbox').colorbox({
			maxHeight: '80%',
			maxWidth: '80%',
			width: 'auto',
			height: 'auto',
			reposition: false
		});
		}
	});

	// Generic colorbox for iframes
	$('.colorbox--iframe').colorbox({
		iframe: true,
		width: '80%',
		height: '80%',
		reposition: false
	});

	$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 10) {
        $(".band--menu").addClass("band--scroll");
    } else {
        $(".band--menu").removeClass("band--scroll");
    }
	});
});